module.exports = __webpack_public_path__ + "img/Beige.e4496df6.png";